export interface TeaserProps {
  imageSrc?: string;
  headline?: string;
  text?: string;
  reverse?: boolean;
}

function Teaser({ imageSrc, headline, text, reverse = false }: TeaserProps) {
  if (reverse) {
    return (
      <div className="flex flex-col md:flex-row md:pb-8 items-center md:items-start">
        <img
          className="w-full md:w-3/5 h-32 sm:h-44 md:h-56 object-cover rounded-lg"
          src={imageSrc}
          alt=""
        />
        <div className="flex flex-col items-center md:items-start my-4 md:ml-8">
          <h2 className="text-sm md:text-lg font-bold mb-2">{headline}</h2>
          <p className="text-sm md:text-md text-gray">{text}</p>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div className="hidden md:flex flex-col md:flex-row md:pb-8 justify-between items-center md:items-start">
          <div className="flex flex-col items-center md:items-start my-4 h-full">
            <h2 className="text-sm md:text-lg font-bold mb-2">{headline}</h2>
            <p className="text-sm md:text-md text-gray">{text}</p>
          </div>
          <img
            className="w-full md:w-3/5 h-32 sm:h-44 md:h-56 object-cover rounded-lg"
            src={imageSrc}
            alt=""
          />
        </div>
        <div className="flex md:hidden flex-col md:flex-row md:pb-8 items-center md:items-start">
          <img
            className="w-full md:w-3/5 h-32 sm:h-44 md:h-56 object-cover rounded-lg"
            src={imageSrc}
            alt=""
          />
          <div className="flex flex-col items-center md:items-start my-4 md:ml-8">
            <h2 className="text-sm md:text-lg font-bold mb-2">{headline}</h2>
            <p className="text-sm md:text-md text-gray">{text}</p>
          </div>
        </div>
      </>
    );
  }
}

export default Teaser;
